// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__XUUyD","open":"sidebar_open__osuTX","close":"sidebar_close__YJeg2"};